import { render } from "./ProductPageImages.vue?vue&type=template&id=e0af7e84"
import script from "./ProductPageImages.vue?vue&type=script&lang=js"
export * from "./ProductPageImages.vue?vue&type=script&lang=js"

import "./ProductPageImages.vue?vue&type=style&index=0&id=e0af7e84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__